<template>
  <div class="container">
    <div class="row justify-content-center align-items-center mh-90vh">
      <div class="col-lg-5 col-md-8">
        <div class="card ps-2 text-white main-color mb-1">
          <div class="card-body h2">
            <span class="test-header-color" v-if="appEnv !== 'production'">
              【テスト環境】
            </span>
            {{config && config.projectName}}
          </div>
        </div>
        <div class="card-group">
          <div class="card p-4">
            <BOverlay :show="overlayShow" rounded="sm">
              <div class="card-body">
                <h1>Login</h1>
                <div class="input-group mb-3 mt-3">
                  <span class="input-group-text">
                    <i class="bi bi-bag"></i>
                  </span>
                  <input class="form-control" :class="{'is-invalid is-invalid-custom' : v$.projectNumber.$error}" type="text" placeholder="案件No" v-model="state.projectNumber" @blur="v$.projectNumber.$touch()">
                  <div class="invalid-feedback" v-for="error in v$.projectNumber.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
                <div class="input-group mb-3">
                  <span class="input-group-text">
                    <i class="bi bi-lock"></i>
                  </span>
                  <input class="form-control" :class="{'is-invalid is-invalid-custom' : v$.password.$error}" type="password" placeholder="パスワード" v-model="state.password" autocomplete="off" @blur="v$.password.$touch()">
                  <div class="invalid-feedback" v-for="error in v$.password.$errors" :key="error.$uid">{{ error.$message }}</div>
                </div>
                <div class="mb-3">
                  <div class="input-group" style="justify-content:space-evenly;" :class="{'is-invalid':v$.customerType.$error}">
                    <div>
                      <input type="radio" id="main" value="main"v-model="state.customerType" @change="v$.customerType.$touch()" style="transform: scale(1.3);" />
                      <label for="main" class="me-4 mb-0 fw-bold ms-1" style="font-size:1.3rem;">新郎・新婦</label>
                    </div>
                    <div>
                      <input type="radio" id="guest" value="guest" v-model="state.customerType" @change="v$.customerType.$touch()" />
                      <label for="guest" class="mb-0 mt-1 ms-1" style="font-size:1rem;">ご親族・ゲスト</label>
                    </div>
                  </div>
                  <div class="invalid-feedback" v-for="error in v$.customerType.$errors" :key="error.$uid">{{ error.$message }}</div>
                  <div style="font-size:0.87rem;" class="mt-4">入室時はマイク・カメラはOFFとなっております。<br>ご準備が整いましたら、ONへの切替をお願いいたします。</div>
                </div>
                <div class="accordion">
                  <BOverlay :show="connectionTestOverlayShow" rounded="sm">
                    <div class="accordion-item">
                      <h2 class="accordion-header">
                        <button class="accordion-button pb-2 pt-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" style="border: 1px solid #0d6efd;" @click="startPreview">
                          カメラ・マイクの接続チェック
                        </button>
                      </h2>
                      <div id="collapseOne" class="accordion-collapse collapse">
                        <div class="accordion-body">
                          <div class="container">
                            <div class="card-body text-center">
                              <div class="fw-bold">
                                <i class="bi bi-check-circle text-success" v-if="cameraStatus"></i>
                                <i class="bi bi-ban text-danger" v-else></i>
                                カメラ：{{ cameraMessage }}
                              </div>
                              <video
                                ref="previewVideo"
                                class="preview mt-2"
                                autoplay
                                muted
                                playsinline>
                              </video>
                              <div class="mt-4">
                                <div class="fw-bold">
                                  <i class="bi bi-check-circle text-success" v-if="microphoneStatus"></i>
                                  <i class="bi bi-ban text-danger" v-else></i>
                                  マイク：{{ microphoneMessage }}
                                </div>
                                <div style="display: flex;">
                                  <i class="bi bi-mic col-1" style="font-size:1.2rem"></i>
                                  <div class="progress mt-2 col-11">
                                    <div class="progress-bar bg-success" :style="{ width: audioLevel + '%'}">
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="mt-4">
                                <div class="fw-bold">
                                  スピーカー
                                </div>
                                <BButton class="mt-2" variant="primary" @click="speakerTest">
                                  テスト音を再生
                                </BButton>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </BOverlay>
                  <div style="font-size:0.87rem;" class="mb-4">接続にお困りの場合は、<span style="color: #0d6efd;">メール内の「打合せ環境設定」</span>をご確認ください。</div>
                </div>
                <div class="row mb-4">
                  <div class="col-12">
                    <BButton class="w-100" variant="primary" @click="login">ログイン</BButton>
                  </div>
                </div>
              </div>
            </BOverlay>
          </div>
        </div>
      </div>
    </div>
    <CommonModal ref="commonModal" modalId="common-modal-ok" />
    <CommonModal ref="commonModalForTabIni" modalId="common-modal-tab" @confirmOk="deleteTabInfo" />
    <div class="p-2">
      <p class="mb-0 text-light h2" id="logo" style="cursor:default;user-select:none" v-if="tabErrorShow">
        <button type="button" class="btn btn-link p-0" style="font-size: 11px; color:red" @click="clickTabIni">
          {{ consts.messages.clearMultipleStart }}
        </button>
      </p>
    </div>
  </div>
</template>
<script>
import { reactive, computed, ref, getCurrentInstance, onMounted, onUnmounted, onBeforeUnmount, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import CommonModal from '@/components/CommonModal' // パスは実際の環境に合わせる
import LoginModel from '@/models/LoginModel'
import MeetingStartModel from '@/models/MeetingStartModel'
import cstore from '@/store/customer-store'
import mstore from '@/store/meeting-store'
import CommonLogModel from '@/models/CommonLogModel'
import useVuelidate from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

export default {
  name: 'CustomerLogin',
  components: { CommonModal },
  setup () {
    const router = useRouter()
    const { appContext } = getCurrentInstance()
    const gp = appContext?.config?.globalProperties || {}
    const config = gp.config ?? {}
    const consts = gp.consts ?? {}
    const state = reactive({
      password: '',
      projectNumber: '',
      customerType: ''
    })
    const cameraStatus = ref(false)
    const microphoneStatus = ref(false)
    const cameraMessage = ref("未確認")
    const microphoneMessage = ref("未確認")
    const previewVideo = ref(null)
    const audioLevel = ref(0)
    const isOpen = ref(false)

    let videoStream = null
    let audioStream = null
    let audioContext = null
    let analyser = null
    let timer = null

    const rules = computed(() => ({
      projectNumber: {
        required: helpers.withMessage('案件Noは必須です', required)
      },
      password: {
        required: helpers.withMessage('パスワードは必須です', required)
      },
      customerType: {
        required: helpers.withMessage('「カップル」、「ご親族・ゲスト」のいずれかを選択してください。', required)
      }
    }))
    const v$ = useVuelidate(rules, state)

    const overlayShow = ref(false)
    const connectionTestOverlayShow = ref(false)
    const appEnv = process.env.APP_ENV
    const tabErrorShow = ref(false)
    // refsをComposition API用に定義
    const commonModal = ref()
    const commonModalForTabIni = ref()
    // loginメソッドをsetup内に移動し、async/awaitを維持
    const login = async () => {
      console.log('[login] clicked', state) // TEMP: ログ出力を確認（後で削除）
      console.log('consts:', consts)
      try {
        // 複数タブのチェック
        if (localStorage.getItem('tabInfo')) {
          commonModal.value.msgBoxConfirm(consts.errorMsg.multipleStart, { title: '', size: 'sm', buttonSize: 'sm', okTitle: '確認', centered: true }) // .valueでrefアクセス
          tabErrorShow.value = true
          return false
        }
        const isFormValid = await v$.value.$validate()
        if (!isFormValid) {
          return false
        }

        overlayShow.value = true
        // テスト用のカメラ、マイクを停止させる
        if (isOpen.value) {
          await stopPreview()
        }

        if (cstore.getters.bothFamilyName1) cstore.commit('setBothFamilyName1', '')
        if (cstore.getters.bothFamilyName2) cstore.commit('setBothFamilyName2', '')
        if (cstore.getters.groomLastName) cstore.commit('setGroomLastName', '')
        if (cstore.getters.groomFirstName) cstore.commit('setGroomFirstName', '')
        if (cstore.getters.groomPhoneNumber) cstore.commit('setGroomPhoneNumber', '')
        if (cstore.getters.brideLastName) cstore.commit('setBrideLastName', '')
        if (cstore.getters.brideFirstName) cstore.commit('setBrideFirstName', '')
        if (cstore.getters.bridePhoneNumber) cstore.commit('setBridePhoneNumber', '')
        if (cstore.getters.mailAddress) cstore.commit('setMailAddress', '')
        if (cstore.getters.brideMailAddress) cstore.commit('setBrideMailAddress', '')
        if (cstore.getters.groomLastNameKana) cstore.commit('setGroomLastNameKana', '')
        if (cstore.getters.groomFirstNameKana) cstore.commit('setGroomFirstNameKana', '')
        if (cstore.getters.brideLastNameKana) cstore.commit('setBrideLastNameKana', '')
        if (cstore.getters.brideFirstNameKana) cstore.commit('setBrideFirstNameKana', '')
        // 一部セッション情報を初期化
        sessionStorage.removeItem('hideMySelfVideo')
        sessionStorage.removeItem('hideYourSelfVideo')
        sessionStorage.removeItem('hideGuest1SelfVideo')
        sessionStorage.removeItem('hideGuest2SelfVideo')
        sessionStorage.removeItem('hideGuest3SelfVideo')
        // 音声、ビデオ情報初期化
        mstore.commit('setIsMicrophoneMute', true)
        if (mstore.getters.speakerVolume) mstore.commit('setSpeakerVolume', 0.5)
        mstore.commit('setIsCameraStop', true)
        if (mstore.getters.isVirtualBackgroundStop) mstore.commit('setIsVirtualBackgroundStop', false)

        const attendeeTypeCustomer = (consts?.attendeeType?.customer ?? '02')

        const reqData = {
          projectNumber: state.projectNumber,
          password: state.password,
          afterMTG: '0',
          attendeeType: attendeeTypeCustomer
        }
        const bvModalLike = {
          msgBoxOk: (msg, options) => {
            if (!commonModal.value) return
            return commonModal.value.msgBoxOk(msg, options)
          }
        }

        const loginModel = await LoginModel.apiSetStore(bvModalLike, reqData, () => {
          overlayShow.value = false
        })

        localStorage.isOnlineMeeting = await loginModel.isOnlineMeeting
        const params = {'attendeeType': consts.attendeeType.customer, 'customerType': state.customerType}

        overlayShow.value = true
        const meetingStartModel = await MeetingStartModel.apiSetStore(null, params, () => {
          overlayShow.value = false
        })
        sessionStorage.meeting = JSON.stringify(meetingStartModel.meeting)
        sessionStorage.attendee = JSON.stringify(meetingStartModel.attendee)
        sessionStorage.customerType = state.customerType

        // DB上のアドレスへの画面遷移
        let targetPath = '/customer/meeting/agenda'
        let urlUpdatTime = Date.parse(meetingStartModel.meetingURL['updatedDateTime'] + '+09:00')
        // DBのデータが一定時間以内ならDBのURLに遷移する

        const urlLimit = (config && typeof config.UrlTransitionTimeLimit === 'number')
          ? config.UrlTransitionTimeLimit
          : 0
        if (Date.now() - urlUpdatTime < urlLimit) {
          let meetingurl = meetingStartModel.meetingURL['currentURLPath']
          if (meetingurl !== '') {
            targetPath = '/customer/' + meetingurl
            if (meetingStartModel.meetingURL['operatingPrivilege'] === '1') {
              cstore.commit('setIsOperationPossible', true)
            } else {
              cstore.commit('setIsOperationPossible', false)
            }
            if (meetingStartModel.meetingURL['customerDisplayFlag'] === '1') {
              cstore.commit('setCustomerDisplayFlag', true)
            } else {
              cstore.commit('setCustomerDisplayFlag', false)
            }
          }

          const suggestionDataStr = meetingStartModel.meetingURL['suggestionData']
          if (suggestionDataStr) {
            const suggestionData = JSON.parse(suggestionDataStr)
            if ('suggestionType' in suggestionData) {
              localStorage.setItem('suggestionType', suggestionData['suggestionType'])
            }
          }
        }

        CommonLogModel.apiSetStore(null, {'timestampMs': Date.now(), 'current_path': router.currentRoute.value.path, 'reloadPath': targetPath}, () => {}) // router.currentRouteに変更
        router.push(targetPath)
      } catch (err) {
        overlayShow.value = false
        const status = err?.response?.status
        const data = err?.response?.data
        console.error('[login] API error', status, data)
        // commonModal.value?.msgBoxOk(
        //  `ログインに失敗しました（${status ?? 'network'}）。` +
        //  `${typeof data === 'string' ? data : JSON.stringify(data)}`
        // )
        CommonLogModel.apiSetStore(null, {'timestampMs': Date.now(), 'errorMessage': err}, () => {})
      }
    }

    const clickTabIni = () => {
      commonModalForTabIni.value.msgBoxConfirm(consts.messages.confirmClear)
    }

    const deleteTabInfo = () => {
      localStorage.removeItem('tabInfo')
    }

    const startCamera = async () => {
      try {
        videoStream = await navigator.mediaDevices.getUserMedia({ video: true })
        previewVideo.value.srcObject = videoStream
        cameraStatus.value = true
        cameraMessage.value = "利用可能"
      }
      catch(error){
        console.log(error)
        handleCameraError(error)
      }
    }

    const startMicrophone = async () => {
      try{
        audioStream = await navigator.mediaDevices.getUserMedia({ audio: true })
        audioContext = new AudioContext()

        const source = audioContext.createMediaStreamSource(audioStream)
        analyser = audioContext.createAnalyser()
        source.connect(analyser)
        startLevelMeter()
        microphoneStatus.value = true
        microphoneMessage.value = "利用可能"
      }
      catch(error){
        console.log(error)
        handleMicrophoneError(error)
      }
    }

    const handleCameraError = (error) => {
      cameraStatus.value = false
      switch(error.name){
        case "NotAllowedError":
          cameraMessage.value = "カメラへのアクセスが許可されていません"
          break

        case "NotFoundError":
          cameraMessage.value = "カメラが見つかりません"
          break

        case "NotReadableError":
          cameraMessage.value = "カメラは他のアプリで使用中です"
          break

        default:
          cameraMessage.value = "カメラを利用できません"
      }
    }

    const handleMicrophoneError = (error) => {
      microphoneStatus.value = false
      switch(error.name){
        case "NotAllowedError":
          microphoneMessage.value = "マイクへのアクセスが許可されていません"
          break

        case "NotFoundError":
          microphoneMessage.value = "マイクが見つかりません"
          break

        case "NotReadableError":
          microphoneMessage.value = "マイクは他のアプリで使用中です"
          break

        default:
          microphoneMessage.value = "マイクを利用できません"
      }
    }


    const startPreview = async () => {
      if (!isOpen.value) {
        connectionTestOverlayShow.value = true
        await startCamera()
        await startMicrophone()
        connectionTestOverlayShow.value = false
        isOpen.value = true
      } else {
        stopPreview()
        isOpen.value = false
      }
    }

    const startLevelMeter = () => {
      if (!analyser) return

      const data = new Uint8Array(analyser.frequencyBinCount)
      timer = setInterval(() => {
        analyser.getByteFrequencyData(data)
        let total = 0
        data.forEach(value => {
          total += value
        })
        audioLevel.value = Math.min(total / data.length, 100)
      }, 100)
    }

    const speakerTest = () => {
      const audioContext = new AudioContext()
      const oscillator = audioContext.createOscillator()
      const gainNode = audioContext.createGain()

      oscillator.type = 'sine'
      oscillator.frequency.value = 250
      oscillator.connect(gainNode)
      gainNode.connect(audioContext.destination)

      oscillator.start()
      setTimeout(() => {
        oscillator.stop()
        audioContext.close()
      }, 1000)
    }

    const stopCamera = () => {
      if (!videoStream) {
        return
      }
      videoStream.getTracks().forEach(track => {
        track.stop()
      })
      if (previewVideo.value) {
        previewVideo.value.srcObject = null
      }
      videoStream = null
      cameraStatus.value = false
      cameraMessage.value = "停止中"
    }

    const stopMicrophone = () => {
      if (!audioStream) {
        return
      }
      audioStream.getTracks().forEach(track => {
        track.stop()
      })
      audioStream = null
      if (timer) {
        clearInterval(timer)
        timer = null
      }
      if (audioContext) {
        audioContext.close()
        audioContext = null
      }
      analyser = null
      audioLevel.value = 0
      microphoneStatus.value = false
      microphoneMessage.value = "停止中"
    }

    const stopPreview = () => {
      stopCamera()
      stopMicrophone()
    }

    onMounted(async () => { // Vue3 Composition APIライフサイクル
      const loginStatus = {
        'afterMTG': '0',
        'prodInst': '0'
      }
      localStorage.setItem('loginStatus', JSON.stringify(loginStatus))
      if (process.env.APP_ENV !== 'production' && config && config.projectName) {
        document.title = '【テスト環境】' + config.projectName
      }
    })

    onUnmounted(() => { // Vue3 Composition APIライフサイクル
      if (LoginModel.getStore()) {
        LoginModel.removeStore()
      }
    })

    onBeforeUnmount(() => {
      if (timer) {
        clearInterval(timer)
      }
      if (stream) {
        stream.getTracks().forEach(track => {
          track.stop()
        })
      }
      if (audioContext) {
        audioContext.close()
      }
    })
    // templateとtemplateRefにバインドするものをreturn
    return {
      state,
      v$,
      overlayShow,
      appEnv,
      tabErrorShow,
      config,
      consts,
      commonModal,
      commonModalForTabIni,
      login, // メソッドをreturn
      clickTabIni,
      deleteTabInfo,
      previewVideo,
      audioLevel,
      startPreview,
      speakerTest,
      connectionTestOverlayShow,
      cameraMessage,
      microphoneMessage,
      cameraStatus,
      microphoneStatus
    }
  }
}
</script>

<style>
.mh-90vh {
  min-height: 90vh;
}

.preview{
  width:100%;
  max-width:640px;
  background:#000;
  border-radius:8px;
  object-fit:cover;
}
</style>
